import { accountingApi } from '../../../../config/apiClient';
import { ACCOUNTING_API } from '../../../../config/api';

// ====== FOLDER TYPES ======

export interface ImageLibraryFolderDto {
  id: string;
  companyId: string;
  branchId?: string;
  name: string;
  color?: string;
  imageCount: number;
  createdBy?: string;
  createdAt: string;
  updatedAt?: string;
  isActive: boolean;
}

export interface CreateImageLibraryFolderDto {
  companyId: string;
  branchId?: string;
  name: string;
  color?: string;
  createdBy?: string;
}

export interface UpdateImageLibraryFolderDto {
  name: string;
  color?: string;
}

// ====== IMAGE TYPES ======

export interface ImageLibraryImageDto {
  id: string;
  companyId: string;
  folderId?: string;
  name: string;
  url: string;
  thumbnailUrl: string;
  size?: number;
  type?: string;
  mediaType?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt?: string;
  isActive: boolean;
}

export interface CreateImageLibraryImageDto {
  companyId: string;
  folderId?: string;
  name: string;
  url: string;
  thumbnailUrl: string;
  size?: number;
  type?: string;
  mediaType?: string;
  createdBy?: string;
}

export interface UpdateImageLibraryImageDto {
  name: string;
  folderId?: string;
}

// ====== FOLDER SERVICE ======

export const ImageLibraryFolderService = {
  /**
   * Şirkete ait tüm klasörleri listele
   */
  async getAllFolders(companyId: string): Promise<ImageLibraryFolderDto[]> {
    const response = await accountingApi.get(ACCOUNTING_API.IMAGE_LIBRARY_FOLDERS);
    return response.data;
  },

  /**
   * Yeni klasör oluştur
   */
  async createFolder(dto: CreateImageLibraryFolderDto): Promise<ImageLibraryFolderDto> {
    const response = await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_FOLDER_CREATE, dto);
    return response.data;
  },

  /**
   * Klasör güncelle
   */
  async updateFolder(companyId: string, id: string, dto: UpdateImageLibraryFolderDto): Promise<ImageLibraryFolderDto> {
    const response = await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_FOLDER_UPDATE(id), dto);
    return response.data;
  },

  /**
   * Klasör sil
   */
  async deleteFolder(companyId: string, id: string): Promise<void> {
    await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_FOLDER_DELETE(id));
  },
};

// ====== IMAGE SERVICE ======

export const ImageLibraryImageService = {
  /**
   * Şirkete ait tüm resimleri listele
   */
  async getAllImages(companyId: string): Promise<ImageLibraryImageDto[]> {
    const response = await accountingApi.get(ACCOUNTING_API.IMAGE_LIBRARY_IMAGES);
    return response.data;
  },

  /**
   * Klasöre ait resimleri listele (folderId null ise ana dizin)
   */
  async getImagesByFolder(companyId: string, folderId?: string): Promise<ImageLibraryImageDto[]> {
    const response = await accountingApi.get(ACCOUNTING_API.IMAGE_LIBRARY_IMAGES_BY_FOLDER(folderId));
    return response.data;
  },

  /**
   * Yeni resim kaydı oluştur
   */
  async createImage(dto: CreateImageLibraryImageDto): Promise<ImageLibraryImageDto> {
    const response = await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_IMAGE_CREATE, dto);
    return response.data;
  },

  /**
   * Resim bilgilerini güncelle (isim, klasör)
   */
  async updateImage(companyId: string, id: string, dto: UpdateImageLibraryImageDto): Promise<ImageLibraryImageDto> {
    const response = await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_IMAGE_UPDATE(id), dto);
    return response.data;
  },

  /**
   * Resim sil
   */
  async deleteImage(companyId: string, id: string): Promise<void> {
    await accountingApi.post(ACCOUNTING_API.IMAGE_LIBRARY_IMAGE_DELETE(id));
  },
};

